import styled from 'styled-components';
import logo from '../../assets/logo.png';
import loginBtn from '../../assets/image/login-btn.png';

const NavbarContainer = styled.div`
  grid-area: 2 / 2 / 3 / 5;
  background: var(--sidebar-bg);
  display: flex;
  align-items: center;
  padding: 0 30px;
  z-index: 90;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const NavBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const LogoImg = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
`;

const BrandText = styled.span`
  font-weight: 900;
  font-size: 24px;
  color: var(--text-white);
  text-transform: uppercase;
  letter-spacing: 1px;

  span {
    color: var(--yellow);
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const NavLink = styled.a`
  color: var(--text-light);
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: var(--text-white);
  }
`;

const LoginButton = styled.button`
  background: repeating-linear-gradient(
    120deg,
    #FFC73A,
    #FFC73A 18px,
    #FFE07A 18px,
    #FFE07A 36px
  );
  color: var(--sidebar-bg);
  font-weight: 900;
  text-transform: uppercase;
  padding: 12px 25px;
  border: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 6px;
  letter-spacing: 0.5px;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  outline: none;
  box-shadow: 0 2px 8px rgba(255,184,0,0.08);
  &:hover {
    background: repeating-linear-gradient(
      120deg,
      #FFE07A,
      #FFE07A 18px,
      #FFC73A 18px,
      #FFC73A 36px
    );
    color: #222;
    box-shadow: 0 0 0 2px #FFE07A, 0 2px 8px rgba(255,184,0,0.2);
  }
`;

const Navbar = () => {
  return (
    <NavbarContainer>
      <Nav>
        <NavBrand>
          <LogoImg src={logo} alt="Logo" />
          <BrandText>BLOXY<span>BET</span></BrandText>
        </NavBrand>
        <NavLinks>
          <NavLink href="#">Stats</NavLink>
          <NavLink href="#">Inventory</NavLink>
          <NavLink href="#">Leaderboard</NavLink>
          <NavLink href="#">Terms</NavLink>
          <NavLink href="#">Settings</NavLink>
          <NavLink href="#">Profile</NavLink>
          <LoginButton>LOGIN</LoginButton>
        </NavLinks>
      </Nav>
    </NavbarContainer>
  );
};

export default Navbar; 